import React, { FC, ReactNode, useState, useEffect } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Transition, TransitionGroup } from 'react-transition-group'
import { MedicalCrossIcon, CloseIcon } from '@components/Icons'
import { Button } from '@components/Button'
import {
  InfoBannerWrapper,
  InnerWrapper,
  MessageWrapper,
  IconWrapper,
  CloseBtnWrapper,
  closeButtonStyles,
  TRANSITION_DELAY
} from './InfoBanner.elements'

type Props = {
  message?: string
  icon?: ReactNode
  initiateOpen?: boolean
}

export const InfoBanner: FC<Props> = ({
  message = 'Medicare Advantage Open Enrollment Begins October 15!',
  icon = <MedicalCrossIcon />,
  initiateOpen,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!initiateOpen)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <TransitionGroup>
      {isOpen && (
        <Transition
          key="info-banner"
          in={!initiateOpen}
          appear={!initiateOpen}
          timeout={TRANSITION_DELAY}
        >
          {state => (
            <InfoBannerWrapper state={state}>
              <InnerWrapper state={state}>
                <IconWrapper>
                  {icon}
                </IconWrapper>
                <MessageWrapper>
                  {message}
                </MessageWrapper>
                <CloseBtnWrapper>
                  <Button
                    onClick={handleClose}
                    circled
                    css={closeButtonStyles}
                    aria-label="Close info banner"
                  >
                    <CloseIcon />
                  </Button>
                </CloseBtnWrapper>
              </InnerWrapper>
            </InfoBannerWrapper>
          )}
        </Transition>
      )}
    </TransitionGroup>
  )
}
